import helpers from './helpers';
import middleware from './middleware';

export default {
  helpers,
  middleware,
};
